<template>
  <form @submit.prevent="$emit('submit', preset)">
    <h3>{{ title }}</h3>

    <SubjectPicker v-model="preset.subject" />

    <StudentPicker v-model="preset.student" />

    <label class="form__label" for="description">Description</label>
    <input
      id="description"
      class="form__input"
      name="description"
      type="text"
      v-model="preset.description"
    />

    <DurationPicker v-model="preset.duration" />

    <div class="preset-form__footer">
      <button type="button" class="button button--border button--cancel" @click.prevent="$emit('cancel')">Cancel</button>
      <button type="submit" class="form__submit">Save Preset</button>
    </div>
  </form>
</template>

<script>
export default {
  name: 'PresetForm',

  props: {
    title: {
      type: String,
      default: 'Add a New Preset'
    },

    preset: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss">
.preset-form__footer {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  button {
    margin-left: 1rem;
  }
}
</style>
